/* RedLine storefront behavior — cart drawer, qty steppers, PDP gallery,
   UGC slider, mobile menu, variant selection, policy TOC anchors. */
(function(){
  var money = function(cents){ return '$' + (cents/100).toFixed(2); };

  /* ---------- Cart drawer (global) ---------- */
  function drawer(){ return document.querySelector('[data-rl-drawer]'); }
  function openDrawer(){ var d=drawer(); if(d){ d.classList.add('is-open'); document.body.style.overflow='hidden'; refreshDrawer(); } }
  function closeDrawer(){ var d=drawer(); if(d){ d.classList.remove('is-open'); document.body.style.overflow=''; } }
  window.addEventListener('redline:cart-open', openDrawer);

  function refreshDrawer(){
    var d=drawer(); if(!d) return;
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(renderDrawer).catch(function(){});
  }
  function renderDrawer(cart){
    var d=drawer(); if(!d) return;
    var list=d.querySelector('[data-rl-drawer-items]');
    var empty=d.querySelector('[data-rl-drawer-empty]');
    var foot=d.querySelector('[data-rl-drawer-foot]');
    updateCartCount(cart.item_count);
    if(!cart.items || cart.items.length===0){
      if(list) list.style.display='none';
      if(foot) foot.style.display='none';
      if(empty) empty.style.display='flex';
      return;
    }
    if(empty) empty.style.display='none';
    if(foot) foot.style.display='block';
    if(list){
      list.style.display='block';
      list.innerHTML = cart.items.map(function(it){
        var img = it.image ? it.image.replace(/(\.[^.]*)$/,'_120x120$1') : '';
        return '<div class="rl-li rl-li--drawer" data-key="'+it.key+'">'+
          '<a class="rl-li__media" href="'+it.url+'">'+(img?'<img src="'+img+'" alt="">':'')+'</a>'+
          '<div><h3 class="rl-li__title"><a href="'+it.url+'">'+it.product_title+'</a></h3>'+
          (it.variant_title?'<div class="rl-li__variant">'+it.variant_title+'</div>':'')+
          '<div class="rl-li__row">'+
            '<div class="rl-qty rl-qty--sm" data-rl-qty data-min="0" data-key="'+it.key+'">'+
              '<button class="rl-qty__btn" data-rl-qty-dec type="button" aria-label="Decrease">&minus;</button>'+
              '<input class="rl-qty__val" data-rl-qty-val type="text" inputmode="numeric" pattern="[0-9]*" value="'+it.quantity+'">'+
              '<button class="rl-qty__btn" data-rl-qty-inc type="button" aria-label="Increase">+</button>'+
            '</div>'+
            '<span class="rl-li__total">'+money(it.final_line_price)+'</span>'+
          '</div>'+
          '<button class="rl-li__remove" data-rl-remove="'+it.key+'" type="button">Remove</button>'+
          '</div></div>';
      }).join('');
    }
    var sub=d.querySelector('[data-rl-subtotal]'); if(sub) sub.textContent=money(cart.total_price);
    updateShipBar(d, cart.total_price);
  }
  function updateShipBar(scope, total){
    var bars=scope.querySelectorAll('[data-rl-ship]');
    bars.forEach(function(bar){
      var threshold=parseInt(bar.getAttribute('data-threshold')||'0',10);
      var msgEl=bar.querySelector('[data-rl-ship-msg]');
      var fill=bar.querySelector('.rl-drawer__ship-fill, .rl-fsbar__fill');
      if(threshold>0){
        var pct=Math.min(100, Math.round(total/threshold*100));
        if(fill) fill.style.width=pct+'%';
        var remaining=threshold-total;
        if(msgEl) msgEl.innerHTML = remaining>0 ? ('Add <strong>'+money(remaining)+'</strong> for free shipping') : '<strong>You&rsquo;ve unlocked free shipping!</strong>';
      }
    });
  }

  /* ---------- Qty steppers (change cart or update a hidden input) ---------- */
  function changeCartQty(key, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(function(cart){
        renderDrawer(cart); refreshCartPage(cart);
      });
  }
  function refreshCartPage(cart){
    updateCartCount(cart.item_count);
    var pageSub=document.querySelector('[data-rl-cart-subtotal]');
    if(pageSub) pageSub.textContent=money(cart.total_price);
    var pageTotal=document.querySelector('[data-rl-cart-total]');
    if(pageTotal) pageTotal.textContent=money(cart.total_price);
    updateShipBar(document, cart.total_price);
    // line totals on cart page
    (cart.items||[]).forEach(function(it){
      var el=document.querySelector('[data-rl-cart-line="'+it.key+'"] [data-rl-line-total]');
      if(el) el.textContent=money(it.final_line_price);
    });
  }
  function applyQty(wrap, val){
    var input=wrap.querySelector('[data-rl-qty-val]');
    var min=parseInt(wrap.getAttribute('data-min')||'1',10);
    var max=parseInt(wrap.getAttribute('data-max')||'99',10);
    val=Math.max(min,Math.min(max,val));
    input.value=val;
    var key=wrap.getAttribute('data-key');
    if(key){
      changeCartQty(key,val);
      if(val===0){ var line=wrap.closest('.rl-li[data-key]'); if(line) line.remove(); return; }
    }
    else { var hidden=wrap.parentNode.querySelector('[data-rl-qty-hidden]'); if(hidden) hidden.value=val; }
    wrap.querySelector('[data-rl-qty-dec]').disabled = val<=min;
    wrap.querySelector('[data-rl-qty-inc]').disabled = val>=max;
  }
  document.addEventListener('click', function(e){
    var inc=e.target.closest('[data-rl-qty-inc]'); var dec=e.target.closest('[data-rl-qty-dec]');
    if(inc||dec){
      var wrap=(inc||dec).closest('[data-rl-qty]'); if(!wrap) return;
      var input=wrap.querySelector('[data-rl-qty-val]');
      var val=parseInt(input.value||'1',10);
      val = inc ? val+1 : val-1;
      applyQty(wrap, val);
    }
    var rm=e.target.closest('[data-rl-remove]');
    if(rm){ changeCartQty(rm.getAttribute('data-rl-remove'),0); var row=rm.closest('[data-key]'); if(row) row.remove(); }
    var close=e.target.closest('[data-rl-drawer-close]'); if(close) closeDrawer();
    var cartBtn=e.target.closest('[data-rl-cart-open]'); if(cartBtn){ e.preventDefault(); openDrawer(); }
    var mopen=e.target.closest('[data-rl-menu-open]'); if(mopen){ var mm=document.querySelector('[data-rl-mobilemenu]'); if(mm) mm.classList.add('is-open'); }
    var mclose=e.target.closest('[data-rl-menu-close]'); if(mclose){ var mm2=document.querySelector('[data-rl-mobilemenu]'); if(mm2) mm2.classList.remove('is-open'); }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeDrawer(); var mm=document.querySelector('[data-rl-mobilemenu]'); if(mm) mm.classList.remove('is-open'); } });
  document.addEventListener('input', function(e){
    var input=e.target.closest('[data-rl-qty-val]'); if(!input) return;
    input.value = input.value.replace(/[^0-9]/g,'');
  });
  document.addEventListener('blur', function(e){
    var input=e.target.closest && e.target.closest('[data-rl-qty-val]'); if(!input) return;
    var wrap=input.closest('[data-rl-qty]'); if(!wrap) return;
    applyQty(wrap, parseInt(input.value||'0',10));
  }, true);
  document.addEventListener('keydown', function(e){
    var input=e.target.closest && e.target.closest('[data-rl-qty-val]'); if(!input) return;
    if(e.key==='Enter'){ e.preventDefault(); input.blur(); }
  });

  /* ---------- Add-to-cart forms (ajax → open drawer) ---------- */
  document.addEventListener('submit', function(e){
    var form=e.target.closest('[data-rl-add-form]'); if(!form) return;
    e.preventDefault();
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){return r.json();}).then(function(){ refreshDrawer(); openDrawer(); });
  });

  function updateCartCount(n){
    document.querySelectorAll('[data-rl-cart-count]').forEach(function(el){
      el.textContent=n; el.hidden = !n;
    });
  }

  /* ---------- PDP gallery ---------- */
  function initGallery(root){
    var main=root.querySelector('[data-rl-gallery-main]');
    var thumbs=root.querySelectorAll('[data-rl-gallery-thumb]');
    var thumbList=Array.prototype.slice.call(thumbs);

    // When a thumbnail carries a data-rl-gallery-thumb-options payload (JSON array of
    // {optionIndex, value}), click the matching option button(s) so the variant picker
    // (and price/variant id via initVariants) follows the photo that was clicked.
    function selectOptionsForThumb(thumb){
      var raw = thumb.getAttribute('data-rl-gallery-thumb-options');
      if(!raw) return;
      var mapping;
      try { mapping = JSON.parse(raw); } catch(e){ return; }
      if(!mapping || !mapping.length) return;
      mapping.forEach(function(entry){
        var group = root.querySelector('[data-rl-option-group][data-option-index="'+entry.optionIndex+'"]');
        if(!group) return;
        var btns = group.querySelectorAll('[data-rl-option-btn]');
        var btn = Array.prototype.filter.call(btns, function(b){
          return b.getAttribute('data-value') === entry.value;
        })[0];
        if(btn && !btn.classList.contains('is-active')) btn.click();
      });
    }

    function activate(i, opts){
      opts = opts || {};
      var t=thumbList[i]; if(!t) return;
      var src=t.getAttribute('data-full'); if(main&&src) main.src=src;
      thumbList.forEach(function(x){x.classList.remove('is-active');}); t.classList.add('is-active');
      if(!opts.skipOptionSync) selectOptionsForThumb(t);
    }
    thumbList.forEach(function(t,i){ t.addEventListener('click', function(){ activate(i); }); });
    var prev=root.querySelector('[data-rl-gallery-prev]');
    var next=root.querySelector('[data-rl-gallery-next]');
    function currentIndex(){ var i=thumbList.findIndex(function(t){return t.classList.contains('is-active');}); return i<0?0:i; }
    if(prev) prev.addEventListener('click', function(){ if(!thumbList.length) return; activate((currentIndex()-1+thumbList.length)%thumbList.length); });
    if(next) next.addEventListener('click', function(){ if(!thumbList.length) return; activate((currentIndex()+1)%thumbList.length); });

    // Reverse direction: an option button click (see initOptionPickers) looks up the
    // matching gallery thumbnail here and activates it, without re-triggering the
    // thumb -> option sync above (which would be a redundant no-op loop back).
    root.__rlActivateThumbForOption = function(optionIndex, value){
      var idx = thumbList.findIndex(function(t){
        var raw = t.getAttribute('data-rl-gallery-thumb-options');
        if(!raw) return false;
        var mapping;
        try { mapping = JSON.parse(raw); } catch(e){ return false; }
        return mapping.some(function(entry){
          return String(entry.optionIndex) === String(optionIndex) && entry.value === value;
        });
      });
      if(idx > -1) activate(idx, {skipOptionSync:true});
    };
  }
  /* ---------- PDP swatches/pills (mirror a hidden <select data-rl-option>) ---------- */
  function initOptionPickers(root){
    root.querySelectorAll('[data-rl-option-group]').forEach(function(group){
      var idx=group.getAttribute('data-option-index');
      var select=root.querySelector('select[data-rl-option][data-option-index="'+idx+'"]');
      var valueLabel=group.querySelector('[data-rl-option-val]');
      var btns=group.querySelectorAll('[data-rl-option-btn]');
      btns.forEach(function(btn){
        btn.addEventListener('click', function(){
          btns.forEach(function(b){ b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if(valueLabel) valueLabel.textContent=btn.getAttribute('data-value');
          if(select){ select.value=btn.getAttribute('data-value'); select.dispatchEvent(new Event('change',{bubbles:true})); }
          // Keep the gallery photo in sync when this option (e.g. Color) has one.
          if(root.__rlActivateThumbForOption) root.__rlActivateThumbForOption(idx, btn.getAttribute('data-value'));
        });
      });
    });
  }
  /* ---------- PDP dropdown option groups (custom-styled, for options with many values) ---------- */
  function initOptionDropdowns(root){
    root.querySelectorAll('[data-rl-dropdown]').forEach(function(dd){
      var trigger=dd.querySelector('[data-rl-dropdown-trigger]');
      var panel=dd.querySelector('[data-rl-dropdown-panel]');
      if(!trigger||!panel) return;
      function close(){ panel.hidden=true; trigger.setAttribute('aria-expanded','false'); dd.classList.remove('is-open'); }
      function open(){ panel.hidden=false; trigger.setAttribute('aria-expanded','true'); dd.classList.add('is-open'); }
      trigger.addEventListener('click', function(e){
        e.stopPropagation();
        if(panel.hidden){ open(); } else { close(); }
      });
      panel.querySelectorAll('[data-rl-option-btn]').forEach(function(btn){
        btn.addEventListener('click', function(){ close(); });
      });
      document.addEventListener('click', function(e){ if(!dd.contains(e.target)) close(); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
    });
  }
  /* ---------- Horizontal sliders (UGC / cross-sell / related) ---------- */
  function initSlider(root){
    var track=root.querySelector('[data-rl-slider-track]');
    var prev=root.querySelector('[data-rl-slider-prev]');
    var next=root.querySelector('[data-rl-slider-next]');
    if(!track) return;
    function step(){ var c=track.querySelector('*'); return c?c.getBoundingClientRect().width+24:320; }
    function update(){ if(prev) prev.disabled=track.scrollLeft<=2; if(next) next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2; }
    if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    if(next) next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    track.addEventListener('scroll',update); update();
  }

  /* ---------- Variant selection (PDP) ---------- */
  function initVariants(root){
    var data=root.querySelector('[data-rl-variant-json]');
    if(!data) return;
    var variants; try{ variants=JSON.parse(data.textContent); }catch(e){ return; }
    var selects=root.querySelectorAll('[data-rl-option]');
    var idInput=root.querySelector('[data-rl-variant-id]');
    var priceEl=root.querySelector('[data-rl-price]');
    var addBtn=root.querySelector('[data-rl-add-btn]');
    function current(){ return Array.prototype.map.call(selects,function(s){return s.value;}); }
    function match(){
      var opts=current();
      return variants.find(function(v){ return v.options.every(function(o,i){return o===opts[i];}); });
    }
    function apply(){
      var v=match();
      if(v){ if(idInput) idInput.value=v.id; if(priceEl) priceEl.textContent=money(v.price);
        if(addBtn){ addBtn.disabled=!v.available; addBtn.textContent=v.available?'Add to cart':'Sold out'; } }
    }
    selects.forEach(function(s){ s.addEventListener('change',apply); });
    apply();
  }

  /* ---------- Policy TOC: inject IDs onto headings + smooth scroll ---------- */
  function initTOC(root){
    var content=root.querySelector('[data-rl-prose]');
    var toc=root.querySelector('[data-rl-toc]');
    if(!content||!toc) return;
    var heads=content.querySelectorAll('h2');
    var frag=[];
    heads.forEach(function(h,i){
      if(!h.id) h.id='sec-'+(i+1)+'-'+(h.textContent||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
      frag.push('<li><a href="#'+h.id+'">'+h.textContent+'</a></li>');
    });
    toc.innerHTML='<ul>'+frag.join('')+'</ul>';
    toc.addEventListener('click', function(e){ var a=e.target.closest('a[href^="#"]'); if(!a) return;
      var t=document.getElementById(a.getAttribute('href').slice(1)); if(t){ e.preventDefault(); window.scrollTo({top:t.getBoundingClientRect().top+window.pageYOffset-90,behavior:'smooth'}); } });
  }

  /* ---------- Collection grid load-more ---------- */
  function initLoadMore(grid){
    var batch=parseInt(grid.getAttribute('data-batch')||'9',10);
    var status=grid.parentNode.querySelector('[data-rl-loadmore-status]'); if(!status) return;
    var total=parseInt(status.getAttribute('data-total')||'0',10);
    var btn=status.querySelector('[data-rl-loadmore-btn]');
    var label=status.querySelector('[data-rl-loadmore-label]');
    var fill=status.querySelector('[data-rl-loadmore-fill]');
    if(!btn) return;
    btn.addEventListener('click', function(){
      var hiddenItems=grid.querySelectorAll('.rl-coll__item[hidden]');
      for(var i=0;i<batch && i<hiddenItems.length;i++){ hiddenItems[i].removeAttribute('hidden'); }
      var shown=total-grid.querySelectorAll('.rl-coll__item[hidden]').length;
      if(label) label.textContent='Showing '+shown+' of '+total;
      if(fill) fill.style.width=Math.round(shown/total*100)+'%';
      if(shown>=total){ status.hidden=true; }
    });
  }

  function initAll(){
    document.querySelectorAll('[data-rl-gallery]').forEach(initOptionPickers);
    document.querySelectorAll('[data-rl-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-rl-gallery]').forEach(initOptionDropdowns);
    document.querySelectorAll('[data-rl-slider]').forEach(initSlider);
    document.querySelectorAll('[data-rl-product]').forEach(initVariants);
    document.querySelectorAll('[data-rl-policy]').forEach(initTOC);
    document.querySelectorAll('[data-rl-loadmore]').forEach(initLoadMore);
    // init standalone (non-cart) steppers disabled states
    document.querySelectorAll('[data-rl-qty]').forEach(function(w){
      var input=w.querySelector('[data-rl-qty-val]'); if(!input) return;
      var val=parseInt(input.value||'1',10);
      var min=parseInt(w.getAttribute('data-min')||'1',10);
      var max=parseInt(w.getAttribute('data-max')||'99',10);
      var d=w.querySelector('[data-rl-qty-dec]'), u=w.querySelector('[data-rl-qty-inc]');
      if(d) d.disabled=val<=min; if(u) u.disabled=val>=max;
    });
    refreshDrawer();
  }
  if(document.readyState!=='loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
})();
